function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

var OpenableComponent = /*#__PURE__*/function (_PureComponent) {
  _inherits(OpenableComponent, _PureComponent);

  var _super = _createSuper(OpenableComponent);

  function OpenableComponent(props) {
    var _this;

    _classCallCheck(this, OpenableComponent);

    _this = _super.call(this, props);
    /**
     * Using binding instead of class properties / arrow functions so
     * open and close can be properly extended if necessary
     */

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false
    });

    _this.open = _this.open.bind(_assertThisInitialized(_this));
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OpenableComponent, [{
    key: "open",
    value: function open() {
      var _this$props = this.props,
          _this$props$onOpen = _this$props.onOpen,
          onOpen = _this$props$onOpen === void 0 ? function () {} : _this$props$onOpen,
          openDelay = _this$props.openDelay;

      if (!this._hasIsOpenProp()) {
        this.setState({
          isOpen: true
        });
      }

      onOpen({
        delay: openDelay
      });
    }
  }, {
    key: "close",
    value: function close() {
      var _this$props2 = this.props,
          _this$props2$onClose = _this$props2.onClose,
          onClose = _this$props2$onClose === void 0 ? function () {} : _this$props2$onClose,
          closeDelay = _this$props2.closeDelay;

      if (!this._hasIsOpenProp()) {
        this.setState({
          isOpen: false
        });
      }

      onClose({
        delay: closeDelay
      });
    }
  }, {
    key: "_hasIsOpenProp",
    value: function _hasIsOpenProp() {
      var isOpen = this.props.isOpen;
      return typeof isOpen === 'boolean';
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      var isOpen = this.props.isOpen;
      var isOpenInternal = this.state.isOpen;
      return this._hasIsOpenProp() ? isOpen : isOpenInternal;
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return OpenableComponent;
}(PureComponent);

OpenableComponent.defaultProps = {
  isOpen: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  closeDelay: 0,
  openDelay: 0
};
OpenableComponent.propTypes = {
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  closeDelay: PropTypes.number,
  openDelay: PropTypes.number
};
export default OpenableComponent;